var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41667 0.75V18.75M14.0833 0.75V18.75M0.75 1.75C0.75 1.48478 0.867063 1.23043 1.07544 1.04289C1.28381 0.855357 1.56643 0.75 1.86111 0.75H19.6389C19.9336 0.75 20.2162 0.855357 20.4246 1.04289C20.6329 1.23043 20.75 1.48478 20.75 1.75V17.75C20.75 18.0152 20.6329 18.2696 20.4246 18.4571C20.2162 18.6446 19.9336 18.75 19.6389 18.75H1.86111C1.56643 18.75 1.28381 18.6446 1.07544 18.4571C0.867063 18.2696 0.75 18.0152 0.75 17.75V1.75Z",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnSelectIcon);
export default __webpack_public_path__ + "static/media/columnSelectIcon.5fbde95d2986d20ecfec9085447baca7.svg";
export { ForwardRef as ReactComponent };